module.exports = __webpack_public_path__ + "img/reset password.92bfffb8.svg";